/**
 * The window a connect round-trip runs in (ADR-029 §2), shared by the connect
 * sheet and Workspace Controls.
 *
 * It is opened synchronously with the click (so it is not blocked as a popup)
 * on about:blank and pointed at the provider once the authorize URL arrives.
 * Its `opener` is cut before it leaves Fias, so the provider's pages can never
 * script or redirect the Fias tab; the outcome comes back on the
 * `fias-connections` BroadcastChannel instead.
 */

const POPUP_NAME = 'fias-connect';
const POPUP_FEATURES = 'popup,width=600,height=760';
const CLOSED_POLL_MS = 500;
/** The return page posts and then closes; give its message time to land. */
const CLOSED_GRACE_MS = 1_000;

export function openConnectPopup(): Window | null {
  const popup = window.open('', POPUP_NAME, POPUP_FEATURES);
  if (popup) popup.opener = null;
  return popup;
}

/**
 * Calls `onClosed` once if the person closes the window before the round-trip
 * reports back. Returns the cleanup.
 */
export function watchConnectPopupClosed(popup: Window, onClosed: () => void): () => void {
  let grace: ReturnType<typeof setTimeout> | undefined;
  const poll = setInterval(() => {
    if (!popup.closed) return;
    clearInterval(poll);
    grace = setTimeout(onClosed, CLOSED_GRACE_MS);
  }, CLOSED_POLL_MS);
  return () => {
    clearInterval(poll);
    if (grace) clearTimeout(grace);
  };
}
